import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, theme, Button, message, Input } from "antd";
import { SkinOutlined, PlusOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";
import { AgentTable } from "../../components/Table";
import { AddAgentModal } from "../../components/ModalForm";

const { Content } = Layout;
const { Search } = Input;

const AgentsPage: React.FC = () => {
  const [agents, setAgents] = useState<any>([]);
  const [agent, setAgent] = useState<any>({});
  const [filtered, setFiltered] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<string>(
    () => sessionStorage.getItem("agentsSearch") || ""
  );
  const [show, setShow] = useState(false);
  const [update, setUpdate] = useState(false);
  const [isActive, setActive] = useState(true);

  const navigate = useNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  setTimeout(() => {
    setActive(false);
  }, 1000);

  const showModal = () => {
    setShow(!show);
    setUpdate(false);
  };

  const showEditModal = (data: any) => {
    setAgent(data);
    setShow(!show);
    setUpdate(true);
  };

  const handleAdd = async (data: any) => {
    console.log(data);
    // return await addAgentApi(data)
    //   .then((res) => {
    //     setAgents([...agents, res.data]);
    //     return res;
    //   })
    //   .catch((err) => {
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  const handleUpdate = async (id: string, data: any) => {
    // return await editAgentApi(id, data)
    //   .then((res) => {
    //     const uppdatedAgents = agents.map((agent: any) => {
    //       if (id === agent.id) {
    //         return { ...agent, ...res.data };
    //       }
    //       return user;
    //     });
    //     setAgents(uppdatedAgents);
    //     return res;
    //   })
    //   .catch((err) => {
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  const handleDelete = (id: string) => {
    // removeAgentApi(id)
    //   .then((res) => {
    //     const deleted = res.data;
    //     setAgents(agents.filter((agent: any) => agent.id !== deleted.id));
    //     return res;
    //   })
    //   .catch((err) => {
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  const onSearch = (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value) sessionStorage.setItem("agentsSearch", value);
    else sessionStorage.removeItem("agentsSearch");
    if (value !== "") {
      const filteredData = agents.filter((row: any) => {
        return Object.values(row)
          .join(" ")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      setFiltered(filteredData);
    }
  };

  // useEffect(() => {
  //   getAgentsApi()
  //     .then((res) => {
  //       setAgents(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar />
        <Layout className="site-layout">
          <TopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <SkinOutlined
                  style={{ paddingRight: "5px", color: "#f04f05" }}
                />
                Agents
              </h2>
              <div className="interactions">
                <Button onClick={showModal} size="large">
                  <PlusOutlined style={{ paddingRight: "5px" }} />
                  Add Agent
                </Button>

                <div>
                  <Search
                    placeholder="Search"
                    size="large"
                    value={searchValue}
                    onChange={(e) => onSearch(e)}
                    style={{ width: "100%", margin: "24px 0" }}
                  />
                </div>
                <AddAgentModal
                  show={show}
                  showModal={showModal}
                  handleAdd={handleAdd}
                />
              </div>

              <AgentTable
                agents={agents}
                filtered={filtered}
                showEditModal={showEditModal}
                handleDelete={handleDelete}
              />
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default AgentsPage;
